import { useState, useEffect } from "react";
import { loadUOMList } from "../services/uomService";

const useUOM = (editID) => {
    const [uom, setUOM] = useState([]);
    const [selectedUOM, setSelectedUOM] = useState(null);
    const [selectedUOMID, setSelectedUOMID] = useState(null);
    const [isUOMDataLoaded, setIsUOMDataLoaded] = useState(false);

    // Fetch department data
    const fetchUOM = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadUOMList(para);
            if (data && data.length > 0) {
                setUOM(data);
                if (selectedID === 0) {
                    setSelectedUOM([]);
                    setSelectedUOMID([]);
                    setIsUOMDataLoaded(true);
                }
                else {
                    const initialUOM = data.find((dept) => dept.id_uom === selectedID);
                    // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                    if (initialUOM) {
                        setSelectedUOM(initialUOM);
                        setSelectedUOMID(initialUOM.id_uom);
                        setIsUOMDataLoaded(true);
                    }
                }


            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isUOMDataLoaded && editID === 0) {
            fetchUOM();
        }
    }, [isUOMDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadUOMByID = async (selectedID) => {
        await fetchUOM(selectedID);
    };

    return {
        uom,
        selectedUOM,
        selectedUOMID,
        setSelectedUOM,
        setSelectedUOMID,
        loadUOMByID,
    };
};

export default useUOM;
